module.exports = {
  title: 'Dynamic Tab Indicator with Reanimated 📊',
  author: 'Enzo Manuel Mangano',
  date: '2023-03-22',
  slug: 'dynamic-tab-indicator',
  tags: ['reanimated'],
};
